<div [formGroup]="formGroup">
    <sc-number-field label="endet in X Tagen" formControlName="period"></sc-number-field>
</div>